module.exports = __webpack_public_path__ + "img/logo_light.b0e69356.svg";